import jwtAuthAxios from "../../services/jwtAuth";
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Slice generik untuk master data sederhana di /v1/master/* (jenis_pendaftaran,
// jalur_pendaftaran, sistem_kuliah, gelombang, status). State dipisah per `key`
// sehingga semua master berbagi satu reducer.

const withToken = async () => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
};

export const fetchMaster = createAsyncThunk("masterPmb/fetch", async ({key, endpoint}) => {
    try {
        await withToken();
        const response = await jwtAuthAxios.get(`${endpoint}`);
        return {key, data: response.data};
    } catch (response) {
        throw response;
    }
});

export const getMasterById = createAsyncThunk("masterPmb/getById", async ({endpoint, id}) => {
    try {
        await withToken();
        const response = await jwtAuthAxios.get(`${endpoint}/${id}`);
        return response.data;
    } catch (response) {
        throw response;
    }
});

export const saveMaster = createAsyncThunk("masterPmb/save", async ({endpoint, payload}) => {
    try {
        await withToken();
        const response = await jwtAuthAxios.post(`${endpoint}`, payload);
        return response.data;
    } catch (response) {
        throw response;
    }
});

export const updateMaster = createAsyncThunk("masterPmb/update", async ({endpoint, payload}) => {
    try {
        await withToken();
        const response = await jwtAuthAxios.put(`${endpoint}`, payload);
        return response.data;
    } catch (response) {
        throw response;
    }
});

export const deleteMaster = createAsyncThunk("masterPmb/delete", async ({endpoint, id}) => {
    try {
        await withToken();
        const response = await jwtAuthAxios.delete(`${endpoint}/${id}`);
        return response.data;
    } catch (response) {
        throw response;
    }
});

const ensure = (state, key) => {
    if (!state[key]) state[key] = {loading: false, data: []};
    return state[key];
};

const masterPmbSlice = createSlice({
    name: "masterPmb",
    initialState: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchMaster.pending, (state, action) => {
                ensure(state, action.meta.arg.key).loading = true;
            })
            .addCase(fetchMaster.fulfilled, (state, action) => {
                const slot = ensure(state, action.payload.key);
                slot.data = action.payload.data;
                slot.loading = false;
            })
            .addCase(fetchMaster.rejected, (state, action) => {
                ensure(state, action.meta.arg.key).loading = false;
            });
    }
});

// Selector pabrik: masterPmbSelector('gelombang')(state) -> {loading, data}
export const masterPmbSelector = (key) => (state) => state.masterPmb[key] || {loading: false, data: []};
export default masterPmbSlice.reducer;
